function Templates() {
    return (
        <>
      <svg   xmlns="http://www.w3.org/2000/svg" height={24} viewBox="0 0 24 24">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M19.5 10V5a.5.5 0 0 0-.5-.5h-4.5V10h5zm0 1.5h-5v8H19a.5.5 0 0 0 .5-.5v-7.5zm-6.5-7H5a.5.5 0 0 0-.5.5v14c0 .28.22.5.5.5h8v-15zM5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2z"
        ></path>
      </svg> 
       </>
    )
  }
  
  export default Templates
  